const BASE_INVENTORY_URL = 'v2/products';

export const INVENTORY_PRODUCTS = `${BASE_INVENTORY_URL}/inventory`;
